export default __webpack_public_path__ + "static/media/ProductsList_img4_Hk.03c77866.webp";